export default "__VITE_ASSET__DKsMzMaY__"